(function($, App, Utils, Components){
  'use strict';

  var logger = new Logger("Smartbanner");

  Components.create('smartbannerComponent', {

    init: function() {
      setTimeout(function() {
        if (typeof smartbanner !== 'undefined') {
          smartbanner.publish();
        }
      }, 1000);
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);